(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["variant-main-picker"] && !Shopify.designMode) return;
  try {
    class KeFormatSelector extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('.shopify-section') || document.body;
      this.productDetails = this.closest('.product-details') || this.section;
      this.lastPhysicalInputValue = null;
      this._isApplyingVariant = false;

      // Restore saved dimension unit ('in' or 'cm')
      let savedUnit = 'in';
      try {
        const u = window.localStorage.getItem('ke_size_unit');
        if (u === 'cm' || u === 'in') savedUnit = u;
      } catch (e) {}
      this.applyUnit(savedUnit, false);

      // Sync initial material & frame state to parent section
      const initMaterial = this.dataset.keMaterial || 'poster';
      const initFrame = this.dataset.keFrame || 'none';
      this.lastCanvasFrame = initMaterial === 'canvas' ? initFrame : 'none';
      this.section.dataset.keMaterial = initMaterial;
      this.section.dataset.keFrame = initFrame;

      // Record initial physical size value
      this.rememberPhysicalSize();
      this.syncCartProperties();
      this.syncFrameNote();

      // Ensure underlying variant-picker matches initial material & frame
      const targetInitPaper = this.getTargetPaperValue(initMaterial, initFrame);
      const checkedPaper = this.querySelector('variant-picker fieldset[data-ke-paper-fieldset="true"] input:checked, variant-picker input[data-option-name="Format"]:checked, variant-picker input[data-option-name="Paper"]:checked');
      if (
        initMaterial !== 'digital' &&
        this.lastPhysicalInputValue &&
        checkedPaper instanceof HTMLInputElement &&
        checkedPaper.value !== targetInitPaper
      ) {
        this.applyVariantSelection(this.lastPhysicalInputValue, targetInitPaper);
      }

      this.handleClick = this.handleClick.bind(this);
      this.handleVariantChange = this.handleVariantChange.bind(this);
      this.handleDocumentClick = this.handleDocumentClick.bind(this);
      this.handleKeyDown = this.handleKeyDown.bind(this);

      this.addEventListener('click', this.handleClick);
      this.addEventListener('change', this.handleVariantChange);
      document.addEventListener('click', this.handleDocumentClick);
      document.addEventListener('keydown', this.handleKeyDown);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
      this.removeEventListener('change', this.handleVariantChange);
      document.removeEventListener('click', this.handleDocumentClick);
      document.removeEventListener('keydown', this.handleKeyDown);
    }

    getFormatInputs() {
      const picker = this.querySelector('variant-picker');
      if (!picker) return [];
      return Array.from(
        picker.querySelectorAll(
          'fieldset[data-ke-paper-fieldset="true"] input, input[data-option-name="Format"], input[data-option-name="Paper"]'
        )
      );
    }

    getTargetPaperValue(material, frameKey) {
      const inputs = this.getFormatInputs();
      const hasVal = (v) => inputs.some((inp) => inp instanceof HTMLInputElement && inp.value === v);
      if (material === 'digital') return 'Digital';
      if (material === 'canvas') {
        if (frameKey === 'canvas' || frameKey === 'stretched') return 'Stretched Canvas';
        if (frameKey === 'oak') return hasVal('Oak Frame') ? 'Oak Frame' : 'Canvas - Oak Frame';
        if (frameKey === 'black') return hasVal('Black Frame') ? 'Black Frame' : 'Canvas - Black Frame';
        return hasVal('Canvas - No Frame') ? 'Canvas - No Frame' : 'Canvas';
      }
      return hasVal('Poster') ? 'Poster' : 'Matte';
    }

    parseSizeCode(str) {
      const m = String(str || '').toLowerCase().match(/(\d+)\D+(\d+)/);
      return m ? `${parseInt(m[1], 10)}x${parseInt(m[2], 10)}` : '';
    }

    getFirstPhysicalSize(posterOnly = false) {
      for (const btn of this.querySelectorAll('[data-ke-size-option]')) {
        if (posterOnly && btn.getAttribute('data-ke-canvas-only-size') === 'true') continue;
        const val = btn.getAttribute('data-ke-size-option');
        if (val) return val;
      }
      return '';
    }

    resolvePosterCompatibleSize(rawVal) {
      if (!rawVal) return this.getFirstPhysicalSize(true);
      const optBtn = Array.from(this.querySelectorAll('[data-ke-size-option]')).find(
        (b) => b.getAttribute('data-ke-size-option') === rawVal
      );
      if (!optBtn || optBtn.getAttribute('data-ke-canvas-only-size') !== 'true') {
        return rawVal;
      }

      // Map Canvas-only sizes (12x16 -> 11x14, 24x30 -> 20x30, and landscape equivalents)
      const code = this.parseSizeCode(rawVal);
      const fallbackCodeMap = {
        '12x16': '11x14',
        '16x12': '14x11',
        '24x30': '20x30',
        '30x24': '30x20',
      };
      const targetCode = fallbackCodeMap[code] || '';
      if (targetCode) {
        for (const btn of this.querySelectorAll('[data-ke-size-option]')) {
          if (btn.getAttribute('data-ke-canvas-only-size') === 'true') continue;
          const bVal = btn.getAttribute('data-ke-size-option') || '';
          if (this.parseSizeCode(bVal) === targetCode) {
            return bVal;
          }
        }
      }
      return this.getFirstPhysicalSize(true);
    }

    applyVariantSelection(sizeRawVal, paperVal) {
      const picker = this.querySelector('variant-picker');
      if (!picker) return;

      let sizeInput = null;
      if (paperVal === 'Digital') {
        sizeInput = picker.querySelector('input[data-ke-digital-input="true"]');
      } else if (sizeRawVal) {
        for (const inp of picker.querySelectorAll('input[data-option-name="Size"]')) {
          if (inp instanceof HTMLInputElement && inp.value === sizeRawVal) {
            sizeInput = inp;
            break;
          }
        }
      }

      let paperInput = null;
      const formatInputs = this.getFormatInputs();
      for (const inp of formatInputs) {
        if (inp instanceof HTMLInputElement && inp.value === paperVal) {
          paperInput = inp;
          break;
        }
      }
      // Fallback to Poster/Matte if product hasn't been expanded with Canvas options yet
      if (!paperInput && paperVal !== 'Digital') {
        for (const inp of formatInputs) {
          if (inp instanceof HTMLInputElement && (inp.value === 'Poster' || inp.value === 'Matte')) {
            paperInput = inp;
            break;
          }
        }
      }

      let changedTarget = null;
      this._isApplyingVariant = true;
      try {
        if (sizeInput instanceof HTMLInputElement && !sizeInput.checked) {
          if (typeof picker.updateSelectedOption === 'function') {
            picker.updateSelectedOption(sizeInput);
          } else {
            sizeInput.checked = true;
          }
          changedTarget = sizeInput;
        }
        if (paperInput instanceof HTMLInputElement && !paperInput.checked) {
          if (typeof picker.updateSelectedOption === 'function') {
            picker.updateSelectedOption(paperInput);
          } else {
            paperInput.checked = true;
          }
          changedTarget = paperInput;
        }
        if (changedTarget) {
          changedTarget.dispatchEvent(new Event('change', { bubbles: true }));
        }
      } finally {
        this._isApplyingVariant = false;
      }
    }

    rememberPhysicalSize() {
      const isPoster = (this.dataset.keMaterial || 'poster') === 'poster';
      const checked = this.querySelector('variant-picker input[data-option-name="Size"]:checked:not([data-ke-digital-input="true"])');
      if (checked instanceof HTMLInputElement) {
        const val = isPoster ? this.resolvePosterCompatibleSize(checked.value) : checked.value;
        this.lastPhysicalInputValue = val;
        this.syncSizeDropdownUI(val);
      } else if (!this.lastPhysicalInputValue) {
        const fallbackVal = this.getFirstPhysicalSize(isPoster);
        if (fallbackVal) {
          this.lastPhysicalInputValue = fallbackVal;
          this.syncSizeDropdownUI(fallbackVal);
        }
      }
    }

    closeAllDropdowns(exceptKey = null) {
      for (const dd of this.querySelectorAll('[data-ke-dropdown]')) {
        const key = dd.getAttribute('data-ke-dropdown');
        if (exceptKey && key === exceptKey) continue;
        dd.classList.remove('is-open');
        const toggle = dd.querySelector('[data-ke-dropdown-toggle]');
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
      }
    }

    toggleDropdown(key) {
      const dd = this.querySelector(`[data-ke-dropdown="${key}"]`);
      if (!dd) return;
      const isOpen = dd.classList.contains('is-open');
      this.closeAllDropdowns(key);
      dd.classList.toggle('is-open', !isOpen);
      const toggle = dd.querySelector('[data-ke-dropdown-toggle]');
      if (toggle) toggle.setAttribute('aria-expanded', !isOpen ? 'true' : 'false');
    }

    handleDocumentClick(event) {
      const target = event.target instanceof Node ? event.target : null;
      if (!target || !this.contains(target)) {
        this.closeAllDropdowns();
      }
    }

    handleKeyDown(event) {
      if (event.key === 'Escape') {
        this.closeAllDropdowns();
      }
    }

    handleClick(event) {
      const target = event.target instanceof Element ? event.target : null;
      if (!target) return;

      const ddToggle = target.closest('[data-ke-dropdown-toggle]');
      if (ddToggle instanceof HTMLElement) {
        event.preventDefault();
        this.toggleDropdown(ddToggle.dataset.keDropdownToggle || '');
        return;
      }

      const sizeOpt = target.closest('[data-ke-size-option]');
      if (sizeOpt instanceof HTMLElement) {
        event.preventDefault();
        const rawVal = sizeOpt.dataset.keSizeOption || '';
        this.selectPhysicalSize(rawVal);
        this.closeAllDropdowns();
        return;
      }

      const matBtn = target.closest('[data-ke-material-btn]');
      if (matBtn instanceof HTMLElement) {
        event.preventDefault();
        this.closeAllDropdowns();
        this.selectMaterial(matBtn.dataset.keMaterialBtn || 'poster');
        return;
      }

      const unitBtn = target.closest('[data-ke-unit-btn]');
      if (unitBtn instanceof HTMLElement) {
        event.preventDefault();
        this.applyUnit(unitBtn.dataset.keUnitBtn || 'in', true);
        return;
      }

      const frameBtn = target.closest('[data-ke-frame-btn]');
      if (frameBtn instanceof HTMLElement) {
        event.preventDefault();
        this.selectFrame(frameBtn.dataset.keFrameBtn || 'none', true, true);
        this.closeAllDropdowns();
      }
    }

    selectPhysicalSize(rawVal) {
      if (!rawVal) return;
      this.lastPhysicalInputValue = rawVal;
      this.syncSizeDropdownUI(rawVal);

      let mat = this.dataset.keMaterial || 'poster';
      const optBtn = Array.from(this.querySelectorAll('[data-ke-size-option]')).find(
        (b) => b.getAttribute('data-ke-size-option') === rawVal
      );
      if (mat === 'poster' && optBtn && optBtn.getAttribute('data-ke-canvas-only-size') === 'true') {
        mat = 'canvas';
        this.syncMaterialUI('canvas');
      }

      const frame = this.dataset.keFrame || 'none';
      const paperVal = this.getTargetPaperValue(mat, frame);
      this.applyVariantSelection(rawVal, paperVal);
      this.syncCartProperties();
      this.syncFrameNote();
    }

    syncSizeDropdownUI(rawVal) {
      let labelIn = rawVal;
      let labelCm = rawVal;

      for (const btn of this.querySelectorAll('[data-ke-size-option]')) {
        const active = btn.getAttribute('data-ke-size-option') === rawVal;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-selected', active ? 'true' : 'false');
        if (active) {
          labelIn = btn.getAttribute('data-ke-label-in') || rawVal;
          labelCm = btn.getAttribute('data-ke-label-cm') || labelIn;
        }
      }

      const currentContainer = this.querySelector('[data-ke-size-current]');
      if (currentContainer) {
        const inSpan = currentContainer.querySelector('.ke-size-text--in');
        const cmSpan = currentContainer.querySelector('.ke-size-text--cm');
        if (inSpan) inSpan.textContent = labelIn;
        if (cmSpan) cmSpan.textContent = labelCm;
      }
    }

    handleVariantChange(event) {
      if (this._isApplyingVariant) return;
      const target = event.target;
      if (!(target instanceof HTMLInputElement)) return;
      if (target.dataset.optionName !== 'Size') return;

      if (target.dataset.keDigitalInput === 'true') {
        if (this.dataset.keMaterial !== 'digital') {
          this.syncMaterialUI('digital');
        }
      } else {
        this.lastPhysicalInputValue = target.value;
        this.syncSizeDropdownUI(target.value);
        if (this.dataset.keMaterial === 'digital') {
          this.syncMaterialUI('poster');
        }
      }
    }

    selectMaterial(material) {
      this.syncMaterialUI(material);

      if (material === 'digital') {
        this.selectFrame('none', false, false);
        const digitalInput = this.querySelector('variant-picker input[data-ke-digital-input="true"]');
        this.applyVariantSelection(digitalInput ? digitalInput.value : 'Digital Download', 'Digital');
      } else {
        const targetFrame = material === 'poster' ? 'none' : (this.lastCanvasFrame || 'none');
        this.selectFrame(targetFrame, false, false);

        let targetSize = this.lastPhysicalInputValue || this.getFirstPhysicalSize(material === 'poster');
        if (material === 'poster') {
          targetSize = this.resolvePosterCompatibleSize(targetSize);
        }
        if (targetSize) {
          this.lastPhysicalInputValue = targetSize;
          this.syncSizeDropdownUI(targetSize);
          const paperVal = this.getTargetPaperValue(material, targetFrame);
          this.applyVariantSelection(targetSize, paperVal);
        }
      }

      this.syncCartProperties();
      this.syncFrameNote();
    }

    syncMaterialUI(material) {
      this.dataset.keMaterial = material;
      if (this.section) this.section.dataset.keMaterial = material;

      for (const btn of this.querySelectorAll('[data-ke-material-btn]')) {
        const active = btn.getAttribute('data-ke-material-btn') === material;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      }
    }

    selectFrame(frameKey, scrollToFirstSlide = false, syncVariant = true) {
      if (this.dataset.keMaterial === 'poster') {
        if (syncVariant && frameKey !== 'none') {
          this.syncMaterialUI('canvas');
          this.lastCanvasFrame = frameKey;
        } else {
          frameKey = 'none';
        }
      } else if (this.dataset.keMaterial === 'canvas') {
        this.lastCanvasFrame = frameKey;
      }

      this.dataset.keFrame = frameKey;
      if (this.section) this.section.dataset.keFrame = frameKey;

      let frameLabel = 'No Frame';
      for (const btn of this.querySelectorAll('[data-ke-frame-btn]')) {
        const active = btn.getAttribute('data-ke-frame-btn') === frameKey;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-selected', active ? 'true' : 'false');
        btn.setAttribute('aria-checked', active ? 'true' : 'false');
        if (active) {
          frameLabel = btn.getAttribute('data-ke-frame-name') || 'No Frame';
        }
      }

      const currentFrameLabel = this.querySelector('[data-ke-frame-current-label]');
      if (currentFrameLabel) {
        currentFrameLabel.textContent = frameLabel;
      }

      const currentFrameSwatch = this.querySelector('[data-ke-dropdown="frame"] .ke-dropdown__trigger [data-ke-frame-current-swatch]');
      if (currentFrameSwatch) {
        currentFrameSwatch.setAttribute('data-ke-frame-current-swatch', frameKey);
      }

      if (syncVariant && this.dataset.keMaterial !== 'digital') {
        const mat = this.dataset.keMaterial || 'poster';
        const targetSize = this.lastPhysicalInputValue || this.getFirstPhysicalSize(mat === 'poster');
        if (targetSize) {
          const paperVal = this.getTargetPaperValue(mat, frameKey);
          this.applyVariantSelection(targetSize, paperVal);
        }
      }

      if (scrollToFirstSlide && this.section) {
        const gallery = this.section.querySelector('media-gallery');
        if (gallery && gallery.slideshow && typeof gallery.slideshow.select === 'function') {
          gallery.slideshow.select(0, undefined, { animate: true });
        }
      }

      this.syncCartProperties();
      this.syncFrameNote();
    }

    applyUnit(unit, persist = true) {
      const cleanUnit = unit === 'cm' ? 'cm' : 'in';
      this.dataset.keUnit = cleanUnit;
      if (this.section) this.section.dataset.keUnit = cleanUnit;

      for (const btn of this.querySelectorAll('[data-ke-unit-btn]')) {
        const active = btn.getAttribute('data-ke-unit-btn') === cleanUnit;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      }

      if (persist) {
        try {
          window.localStorage.setItem('ke_size_unit', cleanUnit);
        } catch (e) {}
      }

      this.dispatchEvent(
        new CustomEvent('ke:unit-change', {
          bubbles: true,
          detail: { unit: cleanUnit },
        })
      );
    }

    syncCartProperties() {
      if (!this.section) return;
      const matInput = this.section.querySelector('input[data-ke-prop-material]');
      const frameInput = this.section.querySelector('input[data-ke-prop-frame]');
      const mat = this.dataset.keMaterial || 'poster';
      const frame = this.dataset.keFrame || 'none';

      if (matInput instanceof HTMLInputElement) {
        matInput.value = mat === 'canvas' ? 'Canvas' : mat === 'digital' ? 'Digital Print' : 'Poster';
      }

      if (frameInput instanceof HTMLInputElement) {
        if (mat === 'digital') {
          frameInput.disabled = true;
        } else {
          frameInput.disabled = false;
          const activeBtn = this.querySelector(`[data-ke-frame-btn="${frame}"]`);
          frameInput.value = activeBtn?.getAttribute('data-ke-frame-name') || 'No Frame';
        }
      }
    }

    syncFrameNote() {
      if (!this.productDetails) return;
      const legacyBlock = this.productDetails.querySelector('[class*="__frame_note"]');
      if (legacyBlock instanceof HTMLElement) {
        legacyBlock.hidden = true;
      }
      const noteEl =
        this.productDetails.querySelector('[data-ke-format-note]') ||
        this.productDetails.querySelector('[class*="__frame_note"] p');
      if (!noteEl) return;

      const mat = this.dataset.keMaterial || 'poster';
      const frame = this.dataset.keFrame || 'none';

      if (mat === 'canvas') {
        if (frame === 'stretched' || frame === 'canvas') {
          noteEl.textContent = 'Glare-free stretched canvas on a wooden inner frame · Arrives ready to hang';
        } else if (frame === 'oak') {
          noteEl.textContent = 'Glare-free matte canvas in an oak floating frame · Arrives ready to hang';
        } else if (frame === 'black') {
          noteEl.textContent = 'Glare-free matte canvas in a black floating frame · Arrives ready to hang';
        } else {
          noteEl.textContent = 'Unframed glare-free cotton canvas · Ships rolled in a protective tube';
        }
      } else if (mat === 'digital') {
        noteEl.textContent = 'Instant digital download · 3 high-resolution 300 ppi JPG files';
      } else {
        noteEl.textContent = 'Archival matte poster print · Ships rolled (click any frame above for ready-to-hang canvas)';
      }
    }
  }

  if (!customElements.get('ke-format-selector')) {
    customElements.define('ke-format-selector', KeFormatSelector);
  }
  } catch(e) { console.error(e); }
})();

})();
